import { render, staticRenderFns } from "./DecorationData.vue?vue&type=template&id=79b32ab0&scoped=true"
import script from "./DecorationData.vue?vue&type=script&lang=js"
export * from "./DecorationData.vue?vue&type=script&lang=js"
import style0 from "./DecorationData.vue?vue&type=style&index=0&id=79b32ab0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b32ab0",
  null
  
)

export default component.exports